import _ from 'lodash'
import {randomUUID} from '@/utils/paperUtil'


export default {
    namespaced: true,
    state: {
        paperGroupScoreList: [],
    },
    getters: {
        paperGroupScoreList(state, getters, rootState, rootGetters) {
            const resultList = _.cloneDeep(state.paperGroupScoreList);
            resultList.forEach((item) => {
                let paperList = []
                item.paperIds.forEach((id) => {
                    paperList.push(rootGetters['question/paper/paperById'](id))
                })
                item.paperList = paperList
            })
            return resultList
        }
    },
    mutations: {
        init(state, { data }) {
            state.paperGroupScoreList = data
        },
        add(state, data) {
            if (data) {
                data.uid = randomUUID()
                data.sort = state.paperGroupScoreList.length
                state.paperGroupScoreList.push(data)
            }
        },
        update(state, data) {
            if (data) {
                const index = state.paperGroupScoreList.findIndex(item => item.uid === data.uid)
                if (index >= 0) {
                    state.paperGroupScoreList.splice(index, 1, data)
                }
            }
        },
        remove(state, uid) {
            const index = state.paperGroupScoreList.findIndex(item => item.uid === uid)
            if (index >= 0) {
                state.paperGroupScoreList.splice(index, 1)
            }
        },
        removePaperId(state, paperId) {
            state.paperGroupScoreList.forEach((item,index) => {
                item.paperIds = _.difference(item.paperIds, [paperId])
            })
        }
    },
    actions: {
        init({ state, rootState, commit,  dispatch,   getters, rootGetters }, paperGroupScoreList) {
            // 初始化
            if (paperGroupScoreList && paperGroupScoreList.length) {
                commit('init', { data: paperGroupScoreList })
            }
        },
        add({ state, rootState, commit,  dispatch,   getters, rootGetters }) {

        }
    }
}
